import BaseService from './base.service';

const baseService = new BaseService('course');

export default {
  findAll: () => baseService.get('findAll'),
  findAllTeachersByCourse: (id: number | string | any) => baseService.get(`teachers/findAll/${id}`),
  create: (data = {}) => baseService.post('create', data),
  findAllBySchool: (schoolId: number | string) => baseService.get(`findAllBySchool/${schoolId}`),
  findAllBySchoolWithStatus: (schoolId: number | string, activeOnly = false) => baseService.get(`findAllBySchoolWithStatus/${schoolId}?activeOnly=${activeOnly}&includeStudentCount=true`),
  deactivateCourse: (id: number | string, deletedBy?: number) => baseService.put(`deactivate/${id}`, { deletedBy }),
  activateCourse: (id: number | string) => baseService.put(`activate/${id}`, {}),
  updateCourse: (id: number | string, data: any) => baseService.put(`update/${id}`, data),
};
